// extracted by mini-css-extract-plugin
export default {"tones":"primary, info, destructive, warning, success, ai, teal, orange, neutral","presets":"primary, secondary, soft, ghost","sizes":"xxs, xs, sm, md, lg, xl, xxl"};